export const languageOptions = [{
    label: 'English',
    value: 'en-US',
    hint: 'EN',
    lang: 'en'
}, {
    label: 'عربى',
    value: 'ar-SD',
    hint: 'AR',
    lang: 'ar'
}, {
    label: 'Español',
    value: 'es',
    hint: 'ES',
    lang: 'es'
}, {
    label: 'français',
    value: 'fr',
    hint: 'FR',
    lang: 'fr'
}, {
    label: 'Deutsche',
    value: 'de',
    hint: 'DE',
    lang: 'de'
}, {
    label: '广东话',
    value: 'cantonese',
    hint: 'zh-cn',
    lang: 'zh-cn'
}, {
    label: '普通話',
    value: 'mandarin',
    hint: 'zh-tw',
    lang: 'zh-tw'
}, {
    label: '한국어',
    value: 'ko',
    hint: 'KO',
    lang: 'ko'
},{
    label: 'lietuvių',
    value: 'lt',
    hint: 'LT',
    lang: 'lt'
},{
    label: 'Türk',
    value: 'tr',
    hint: 'TR',
    lang: 'tr'
},{
    label: 'português',
    value: "pt",
    hint: 'PT',
    lang: 'pt'
}];

export const fontSizes =  [
    {
        label: '10',
        value: 10/12
    },
    {
        label: '11',
        value: 11/12
    },
    {
        label: '12',
        value: 12/12
    },
    {
        label: '14',
        value: 14/12
    },
    {
        label: '16',
        value: 16/12
    },
    {
        label: '18',
        value: 18/12
    },
    {
        label: '24',
        value: 24/12
    },
];

export const defaultFontSizeMultiplierForJr = 18/12;
export const defaultFontSizeMultiplier = 12/12;

export const caseSizes = [ 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 16, 18, 20, 25, 30, 40, 50, 60, 70, 80 ];
export const caseSizesDefault = 12;

export const dataColors = [
    {
        label: 'Standard',
        value: 'colorsLikeTinkerPlots'
    },
    {
        label: 'Colorblind Safe',
        value: 'colorBlindSafe'
    },
    {
        label: 'Grayscale',
        value: 'grayScaleColors'
    }
]

export const colorContrasts = [
    {
        label: 'Default',
        value: 'tuva',
        overridingValue: 'tuva-junior'
    },
    {
        label: 'Reverse Contrast',
        value: 'reverse-contrast'
    },
    // see also testThemes in plotUtil.js
]

export let decimalPoints = [];
export const minDecimalPoints = 0;
export const maxDecimalPoints = 15;

export const keyboardShortcuts = [
    {
        component : "Common Actions",
        shortcuts : [{
            desc : "Reset Plot",
            mac : "command+r",
            windows : "ctrl+r"
        },
        {
            desc : "Undo Action",
            mac : "command+z",
            windows : "ctrl+z"
        },
        {
            desc : "Redo Action",
            mac : "command+y",
            windows : "ctrl+y"
        },
        {
            desc : "Exclude Selected Case",
            mac : "command+e",
            windows : "ctrl+e"
        },
        {
            desc : "Keep Only Selected Cases",
            mac : "command+k",
            windows : "ctrl+k"
        },
        {
            desc : "Clear All Reference Lines",
            mac : "command+\\",
            windows : "ctrl+\\"
        },
        {
            desc : "Clear All Annotations",
            mac : "command+a",
            windows : "ctrl+a"
        },
        {
            desc : "Reset All Filters",
            mac : "command+f",
            windows : "ctrl+f"
        },
        {
            desc : "Download Screenshot",
            mac : "command+s",
            windows : "ctrl+s"
        },
        {
            desc : "Keyboard Shortcuts",
            mac : "command+/",
            windows : "ctrl+/"
        }]
    },{
        component : "Graph Actions",
        shortcuts : [{
            desc : "Create Dot Plot",
            mac : "d",
            windows : "d"
        },
        {
            desc : "Create Line Graph",
            mac : "l+g",
            windows : "l+g"
        },
        {
            desc : "Create Line Graph by Category",
            mac : "l+c",
            windows : "l+c"
        },
        {
            desc : "Create Pie Chart",
            mac : "p",
            windows : "p"
        },
        {
            desc : "Create Bar Chart of Frequencies",
            mac : "b+f",
            windows : "b+f"
        },
        {
            desc : "Create Bar Chart of Values",
            mac : "b+v",
            windows : "b+v"
        },
        {
            desc : "Create Bar Chart of Sums",
            mac : "b+s",
            windows : "b+s"
        },
        {
            desc : "Create Bar Chart of Means",
            mac : "b+m",
            windows : "b+m"
        },
        {
            desc : "Create Stretched Bar Chart",
            mac : "b+t",
            windows : "b+t"
        },
        {
            desc : "Create Frequency Histogram",
            mac : "h+f",
            windows : "h+f"
        },
        {
            desc : "Create Relative Proportion Histogram",
            mac : "h+r",
            windows : "h+r"
        },
        {
            desc : "Create Relative Percentage Histogram",
            mac : "h+p",
            windows : "h+p"
        },
        {
            desc : "Create Box Plot",
            mac : "x+p",
            windows : "x+p"
        },
        {
            desc : "Create Box Plot with Outliers",
            mac : "x+o",
            windows : "x+o"
        },
        {
            desc : "Create Box and Dot Plot",
            mac : "x+d",
            windows : "x+d"
        },
        {
            desc : "Create Geographic Map",
            mac : "m",
            windows : "m"
        }]
    },
    {
        component : "Data Analysis Actions",
        shortcuts : [{
            desc : "Toggle Mean",
            mac : "command+ctrl+m",
            windows : "ctrl+shift+m"
        },
        {
            desc : "Toggle Median",
            mac : "command+ctrl+e",
            windows : "ctrl+shift+e"
        },
        {
            desc : "Toggle Mode",
            mac : "command+ctrl+o",
            windows : "ctrl+shift+o"
        },
        {
            desc : "Toggle Mean Average Deviation",
            mac : "command+ctrl+a",
            windows : "ctrl+shift+a"
        },
        {
            desc : "Toggle Standard Deviation",
            mac : "command+ctrl+s",
            windows : "ctrl+shift+s"
        },
        {
            desc : "Toggle Variance",
            mac : "command+ctrl+v",
            windows : "ctrl+shift+v"
        },
        {
            desc : "Toggle Interquartile Range",
            mac : "command+ctrl+i",
            windows : "ctrl+shift+i"
        },
        {
            desc : "Toggle Labels",
            mac : "command+ctrl+l",
            windows : "ctrl+shift+l"
        },
        {
            desc : "Dividers",
            mac : "command+ctrl+p",
            windows : "Ctrl+Shift+p"
        },
        {
            desc : "Least Squares Line",
            mac : "command+ctrl+u",
            windows : "ctrl+shift+u"
        },
        {
            desc : "Toggle Squares",
            mac : "command+ctrl+w",
            windows : "ctrl+shift+w"
        },
        {
            desc : "Clear All Annotations",
            mac : "command+a",
            windows : "ctrl+a"
        },
        {
            desc : "Sample Data",
            mac : "option+d",
            windows : "alt+d"
        },
        {
            desc : "Model Functions",
            mac : "option+f",
            windows : "alt+f"
        },
        {
            desc : "Add New Attribute",
            mac : "option+a",
            windows : "alt+a"
        }]
    },
    {
        component : "Navigation",
        shortcuts : [{
            desc : "Open or Close Table View",
            mac : "option+t",
            windows : "alt+t"
        },
        {
            desc : "Open or Close Summary View",
            mac : "option+s",
            windows : "alt+s"
        },
        {
            desc : "Expand or Collapse Table or Summary View",
            mac : "ctrl+shift+f",
            windows : "ctrl+shift+f"
        },
        {
            desc : "Focus Toolbar Menu",
            mac : "shift+m",
            windows : "shift+m"
        },
        {
            desc : "Focus Case Card",
            mac : "shift+c",
            windows : "shift+c"
        },
        {
            desc : "Focus Plot Area",
            mac : "shift+p",
            windows : "shift+p"
        },
        {
            desc : "Focus Plot Title",
            mac : "shift+t",
            windows : "shift+t"
        },
        {
            desc : "Focus X Axis",
            mac : "shift+x",
            windows : "shift+x"
        },
        {
            desc : "Focus Y Axis",
            mac : "shift+y",
            windows : "shift+y"
        },
        {
            desc : "Focus on Legend",
            mac : "shift+l",
            windows : "shift+l"
        },
        {
            desc : "Focus Annotate Menu",
            mac : "ctrl+option+a",
            windows : "ctrl+alt+a"
        },
        {
            desc : "Focus Count and Percent Menu",
            mac : "ctrl+option+n",
            windows : "ctrl+alt+n"
        },
        {
            desc : "Focus Help Menu",
            mac : "ctrl+option+h",
            windows : "ctrl+alt+h"
        },
        {
            desc : "Focus Filter Data Menu",
            mac : "ctrl+option+f",
            windows : "ctrl+alt+f"
        },
        {
            desc : "Focus Model Data Menu",
            mac : "ctrl+option+m",
            windows : "ctrl+alt+m"
        },
        {
            desc : "Focus Reference Lines and Dividers Menu",
            mac : "ctrl+option+l",
            windows : "ctrl+alt+l"
        },
        {
            desc : "Focus Statistical Measures Menu",
            mac : "ctrl+option+s",
            windows : "ctrl+alt+s"
        }]
    },
    {
        component : "Accessibility & Settings",
        shortcuts : [{
            desc : "Open Accessibility Card",
            mac : "option+z",
            windows : "alt+z"
        },
        {
            desc : "Toggle Attribute Keyboard Support",
            mac : "command+ctrl+k",
            windows : "ctrl+shift+k"
        },
        {
            desc : "Speak Dataset Description",
            mac : "shift+d",
            windows : "shift+d"
        },
        {
            desc : "Speak Plot Area Summary",
            mac : "shift+s",
            windows : "shift+s"
        },
        {
            desc : "Open Settings Card",
            mac : "option+e",
            windows : "alt+e"
        }]
    },
    {
        component : "Rounding",
        shortcuts : [{
            desc : "Less Precision (More Rounding)",
            mac : "command+ctrl+1",
            windows : "ctrl+shift+1"
        },
        {
            desc : "More Precision (Less Rounding)",
            mac : "command+ctrl+2",
            windows : "ctrl+shift+2"
        },
        {
            desc : "Significant Figures Only",
            mac : "command+ctrl+0",
            windows : "ctrl+shift+0"
        },
        {
            desc : "High Precision: +6 digits",
            mac : "command+ctrl+6",
            windows : "ctrl+shift+6"
        }]
    }
];

for(var j=minDecimalPoints;j<=maxDecimalPoints;j++){
    decimalPoints.push({ value: j, label: j.toString() });
}

export const validNumberRegex = new RegExp(/^[-+]?(\d+\.?|\d*\.\d+)$/);
